<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 12/8/2022
  -->

<template>
	<el-form
		:model="model"
		:rules="rules"
		v-bind="$attrs"
		ref="mainForm"
		:class="{'qwoach-form': addQwoachFormClass}"
		@submit.native.prevent>

		<slot></slot>

	</el-form>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "QwForm",
	extends: BaseComponent,
	inheritAttrs: false,

	props: {
		model: {required: true},
		rules: Object,
		addQwoachFormClass: {Boolean, default: true},
	},

	methods: {
		validate(callback) {
			return this.$refs.mainForm.validate(callback)
		},

		clearValidate(){
			this.$refs.mainForm.clearValidate()
		}
	},
}
</script>

<style lang="scss">

</style>
